import { travelGuideQueryKeys as e } from "./travelGuideQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { guestGuidesApi as n } from "@maat/api-main";
//#region src/travelGuides/useGuestGuides.ts
var r = (r) => {
	let { workspaceId: i, location: a } = r ?? {};
	return t({
		queryKey: e.guestList(i, a),
		queryFn: () => n.list({
			workspace_id: i,
			location: a
		})
	});
}, i = (r) => t({
	queryKey: e.guestDetail(r),
	queryFn: () => n.get(r),
	enabled: !!r
});
//#endregion
export { i as useGuestGuideQuery, r as useGuestGuidesQuery };
